const pipelineTypes = {
  LEAD: { label: 'Lead', value: 'LEAD' },
  ACTIVE: { label: 'Active', value: 'ACTIVE' },
  LOST: { label: 'Lost', value: 'LOST' },
};

const anticipatedVolumeTypes = {
  YEARLY: { label: 'Yearly', value: 'YEARLY' },
  MONTHLY: { label: 'Monthly', value: 'MONTHLY' },
};

const leadStatuses = {
  ACTIVE: { label: 'Active', value: 'ACTIVE' },
  LOST: { label: 'Lost', value: 'LOST' },
  WON: { label: 'Won', value: 'WON' },
};

const leadActivityCategories = {
  ACTIVITY: { label: 'Activity', value: 'ACTIVITY' },
  CALL: { label: 'Call', value: 'CALL' },
  MEETING: { label: 'Meeting', value: 'MEETING' },
  TRAINING: { label: 'Training', value: 'TRAINING' },
  DEMO: { label: 'Demo', value: 'DEMO' },
};

const caseVolumeTiers = {
  TIER_1: { min: 20, max: 100 },
  TIER_2: { min: 10, max: 20 },
  TIER_3: { min: 5, max: 10 },
  TIER_4: { min: 0, max: 5 },
};

const leadActivityDurationOptions = {
  '5_MINUTES': { label: '5 minutes', value: '5_MINUTES' },
  '10_MINUTES': { label: '10 minutes', value: '10_MINUTES' },
  '20_MINUTES': { label: '20 minutes', value: '20_MINUTES' },
  '30_MINUTES': { label: '30 minutes', value: '30_MINUTES' },
  '1_HOUR': { label: '1 hour', value: '1_HOUR' },
  '2_HOURS': { label: '2 hours', value: '2_HOURS' },
  '3_HOURS': { label: '3 hours', value: '3_HOURS' },
  HALF_DAY: { label: 'Half day', value: 'HALF_DAY' },
  FULL_DAY: { label: 'Full day', value: 'FULL_DAY' },
};

const LOST_LEADS_PIPELINE_ID = 'LOST_LEADS_PIPELINE';
const ACTIVE_SURGEONS_PIPELINE_ID = 'ACTIVE_SURGEONS_PIPELINE';

const defaultRankingAndActivity = {
  1: { rankCategory: 'E', activityTarget: 1 },
  2: { rankCategory: 'E', activityTarget: 1 },
  3: { rankCategory: 'E', activityTarget: 1 },
  4: { rankCategory: 'E', activityTarget: 1 },
  5: { rankCategory: 'D', activityTarget: 2 },
  6: { rankCategory: 'D', activityTarget: 2 },
  7: { rankCategory: 'D', activityTarget: 2 },
  8: { rankCategory: 'D', activityTarget: 2 },
  9: { rankCategory: 'C', activityTarget: 3 },
  10: { rankCategory: 'C', activityTarget: 3 },
  11: { rankCategory: 'C', activityTarget: 3 },
  12: { rankCategory: 'C', activityTarget: 3 },
  13: { rankCategory: 'B', activityTarget: 6 },
  14: { rankCategory: 'B', activityTarget: 6 },
  15: { rankCategory: 'B', activityTarget: 6 },
  16: { rankCategory: 'B', activityTarget: 6 },
  17: { rankCategory: 'A', activityTarget: 8 },
  18: { rankCategory: 'A', activityTarget: 8 },
  19: { rankCategory: 'A', activityTarget: 8 },
  20: { rankCategory: 'A', activityTarget: 8 },
};

export {
  pipelineTypes,
  anticipatedVolumeTypes,
  leadStatuses,
  LOST_LEADS_PIPELINE_ID,
  ACTIVE_SURGEONS_PIPELINE_ID,
  defaultRankingAndActivity,
  leadActivityCategories,
  leadActivityDurationOptions,
  caseVolumeTiers,
};
